export default "__VITE_ASSET__Biu3_Yv6__";